// extracted by mini-css-extract-plugin
export default {"source":"Source_source__dgjEb","sourceLabel":"Source_sourceLabel__Qx9cP","sourceLink":"Source_sourceLink__n6hqk","sourceImage":"Source_sourceImage__2vrzN"};